/*
 * Disaster Tees — inline size quick-add.
 *
 * The tile size buttons are real submit buttons inside Horizon's
 * product-form-component, so the cart drawer, error handling and analytics all
 * come along for free. Horizon builds its payload with `new FormData(form)`,
 * which ignores the submitter, so the only thing left to do is point the
 * form's hidden variant input at whichever size was pressed — before the
 * submit event reaches Horizon's handler.
 *
 * pointerdown fires before click, which fires before submit, so the value is
 * always in place by the time the form is read.
 */

(() => {
  const setVariant = (button) => {
    const variantId = button.dataset.dtVariant;
    if (!variantId) return;

    const form = button.closest('form');
    const input = form?.querySelector('input[name="id"]');

    if (input instanceof HTMLInputElement) {
      input.value = variantId;
    }
  };

  const onPointerDown = (event) => {
    const button =
      event.target instanceof Element
        ? event.target.closest('.dt-size[data-dt-variant], .dt-cell__size[data-dt-variant]')
        : null;

    if (button) {
      setVariant(button);
    }
  };

  const onClick = (event) => {
    const button =
      event.target instanceof Element
        ? event.target.closest('.dt-size[data-dt-variant], .dt-cell__size[data-dt-variant]')
        : null;

    if (!button) return;

    setVariant(button);


    setTimeout(() => {
      const drawer = document.querySelector('#cart-drawer');

      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      }
    }, 500);
  };

  document.addEventListener('pointerdown', onPointerDown);
  document.addEventListener('click', onClick);
})();

